import type { FunctionComponent } from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'

export type BuildOfMaterialsComponent = {
  inlineInput: FunctionComponent<InlineInputProps>
}

export const defaultComponent: BuildOfMaterialsComponent = {
  inlineInput: InlineInput,
}
